// extracted by mini-css-extract-plugin
module.exports = {"container":"_1LCB1","image":"_1r8-t","desktop":"vJqaj","mobile":"oPzvP","imageFit":"_2Fxqw"};